/* @flow */
import React from 'react';

import Navigation from 'components/UIKit/Details/Navigation';
import NavItem from 'components/UIKit/Details/Navigation/NavItem';
import Count from 'components/UIKit/Details/Navigation/Count';
import CaseIcon from 'components/icons/CaseIcon';
import ClinicalIcon from 'components/icons/ClinicalIcon';
import AnnotationIcon from 'components/icons/AnnotationIcon';
import TransactionIcon from 'components/icons/TransactionIcon';
import DetailsIcon from 'components/icons/DetailsIcon';
import DownloadIcon from 'components/icons/DownloadIcon';

export default function CaseDetailsNavigation({
  details, active, handleOnClick
}: any): React.Element {
  let item = (details || {}).item;
  let annotationsCount = ((item || {}).annotations || []).length;
  let transactionsCount = ((item || {})._transaction_logs || []).length;

  let type = <CaseIcon />;

  return (
    <Navigation details={details} type={type} active={active} handleOnClick={handleOnClick}>
      <NavItem spyId="actions" tooltip={{text: 'Actions'}}>
        <DownloadIcon />
      </NavItem>
      <NavItem spyId="details" tooltip={{text: 'Information'}}>
        <DetailsIcon />
      </NavItem>
      <NavItem spyId="related entities" tooltip={{text: 'Related Entities'}}>
        <ClinicalIcon />
      </NavItem>
      <NavItem spyId="annotations" tooltip={{text: 'Annotations'}}>
        <AnnotationIcon style={{color: '#888'}} />
        <Count>{annotationsCount}</Count>
      </NavItem>
      <NavItem spyId="transactions" tooltip={{text: 'Transactions'}}>
        <TransactionIcon style={{color: '#888'}} />
        <Count>{transactionsCount}</Count>
      </NavItem>
    </Navigation>
  );
}
